export default "__VITE_ASSET__aX4oACyv__"